{
  "app": {
    "name": "WebSede",
    "tagline": "Alan adınız, e-postanız, verileriniz.",
    "offline": "Çevrimdışısınız. Son postalar, takvim, görevler ve notlar bu cihazdan gösteriliyor; değişiklikler için bağlantı gerekir."
  },
  "nav": {
    "mail": "Posta",
    "calendar": "Takvim",
    "contacts": "Kişiler",
    "tasks": "Görevler",
    "notes": "Notlar",
    "drive": "Drive",
    "admin": "Yönetim",
    "domains": "Alan adları",
    "settings": "Ayarlar",
    "security": "Güvenlik",
    "notifications": "Bildirimler",
    "mailSettings": "Posta",
    "devices": "Telefon ve uygulamalar"
  },
  "domains": {
    "searchPlaceholder": "Alan adınızı arayın, örneğin ornek.com",
    "search": "Ara",
    "available": "Müsait",
    "unavailable": "Alınmış",
    "premium": "Premium",
    "unsupported": "Sunulmuyor",
    "priceNote": "Registry fiyatı artı ICANN ücreti artı kart komisyonu. Üstüne hiçbir şey eklemiyoruz.",
    "perYear": "yıllık",
    "register": "Kaydet",
    "owned": "Alan adlarınız",
    "none": "Henüz alan adı yok. Aşağıdan arayıp maliyetine kaydedin.",
    "expires": "yenileme {{date}}",
    "autoRenew": "otomatik yenileme",
    "locked": "kilitli",
    "privacy": "WHOIS gizliliği",
    "orders": "Siparişler",
    "status": {
      "pending_registration": "kaydediliyor",
      "active": "etkin",
      "pending_transfer": "transfer bekliyor",
      "expired": "süresi dolmuş",
      "redemption": "kurtarma dönemi",
      "transferred_out": "dışarı transfer edildi",
      "cancelled": "iptal",
      "pending_verification": "doğrulama bekliyor"
    },
    "renew": "Yenile",
    "renewNow": "Şimdi yenile",
    "renewFor": "{{domain}} yenile",
    "newExpiry": "yeni son tarih {{date}}",
    "autoRenewOn": "Otomatik yenileme açık",
    "autoRenewOff": "Otomatik yenileme kapalı",
    "autoRenewHint": "Süre dolmadan 14 gün önce kayıtlı karttan çekim yapar ve makbuz göndeririz.",
    "renewal": "yenileme",
    "connected": "başka yerde kayıtlı",
    "connect": {
      "title": "Zaten sahip olduğunuz bir alan adını kullanın",
      "hint": "Başka bir yerde mi kayıtlı? E-posta için burada kullanmak üzere bağlayın. Alan adı mevcut kayıt firmanızda kalır, oraya birkaç DNS kaydı eklersiniz.",
      "placeholder": "sirketiniz.com",
      "button": "Bağla"
    },
    "noneConnect": "Henüz alan adı yok. Sahip olduğunuz bir alan adını aşağıdan bağlayın."
  },
  "roles": {
    "owner": "Sahip",
    "admin": "Yönetici",
    "billing": "Faturalama",
    "user": "Üye",
    "group_manager": "Grup yöneticisi"
  },
  "auth": {
    "signOut": "Çıkış yap",
    "fields": {
      "email": "E-posta",
      "password": "Parola",
      "passwordHint": "En az 10 karakter. Kısa bir cümle iyi bir seçimdir.",
      "displayName": "Adınız",
      "tenantName": "Çalışma alanı adı",
      "locale": "Dil"
    },
    "login": {
      "title": "Giriş yap",
      "subtitle": "Tekrar hoş geldiniz.",
      "submit": "Giriş yap",
      "noAccount": "Henüz çalışma alanınız yok mu?",
      "createWorkspace": "Oluşturun",
      "or": "veya",
      "passkey": "Passkey ile giriş yap",
      "forgot": "Parolanızı mı unuttunuz?",
      "emailHint": "Hesap e-postanız ya da posta kutusu adresiniz."
    },
    "signup": {
      "title": "Çalışma alanınızı oluşturun",
      "subtitle": "Ekibiniz, alan adınız, verileriniz.",
      "tenantHint": "Genellikle şirket veya ekip adınız.",
      "submit": "Çalışma alanı oluştur",
      "haveAccount": "Zaten hesabınız var mı?",
      "signIn": "Giriş yapın",
      "forDomain": "{{domain}} alan adının sahibi olacak çalışma alanını oluşturun. Hemen ardından ödeme adımı gelir.",
      "closed": "WebSede çok yakında açılıyor. Açılışa kadar kayıt yalnızca erken kullanıcılara açık; erken erişim için support@websede.com adresine yazın.",
      "agree": "Çalışma alanı oluşturarak <terms>Hizmet Şartları</terms>'nı ve <aup>Kabul Edilebilir Kullanım Politikası</aup>'nı kabul etmiş olursunuz."
    },
    "mfa": {
      "title": "İkinci adım",
      "subtitle": "Doğrulayıcı uygulamanızdaki kodu girin.",
      "code": "Doğrulayıcı kodu",
      "recoveryCode": "Kurtarma kodu",
      "submit": "Devam et",
      "useRecovery": "Kurtarma kodu kullan",
      "useCode": "Doğrulayıcı uygulamayı kullan"
    },
    "invite": {
      "title": "Çalışma alanına katılın",
      "subtitle": "{{tenant}} çalışma alanına {{role}} olarak davet edildiniz.",
      "submit": "Hesabımı oluştur",
      "invalidTitle": "Bu davet geçerli değil",
      "invalidSubtitle": "Süresi dolmuş veya iptal edilmiş olabilir. Yöneticinizden yeni bir davet isteyin.",
      "agree": "Çalışma alanına katılarak <terms>Hizmet Şartları</terms>'nı ve <aup>Kabul Edilebilir Kullanım Politikası</aup>'nı kabul etmiş olursunuz."
    },
    "forgot": {
      "title": "Parolanızı mı unuttunuz?",
      "subtitle": "Yeni parola seçmeniz için size bir bağlantı göndereceğiz.",
      "submit": "Sıfırlama bağlantısı gönder",
      "back": "Girişe dön",
      "sentTitle": "Gelen kutunuzu kontrol edin",
      "sentSubtitle": "{{email}} bir hesaba aitse sıfırlama bağlantısı yolda.",
      "sentHint": "Bağlantı bir saat geçerlidir. Birkaç dakika içinde gelmezse spam klasörüne bakın."
    },
    "reset": {
      "title": "Yeni parola seçin",
      "subtitle": "Ardından tüm cihazlardan çıkış yapılacak.",
      "newPassword": "Yeni parola",
      "confirmPassword": "Parolayı tekrar yazın",
      "mismatch": "İki parola birbirinden farklı.",
      "submit": "Parolayı ayarla",
      "requestAgain": "Yeni bağlantı iste",
      "invalidTitle": "Bu bağlantı geçerli değil",
      "invalidSubtitle": "Süresi dolmuş veya daha önce kullanılmış olabilir.",
      "doneTitle": "Parola değiştirildi",
      "doneSubtitle": "Yeni parolanızla giriş yapın."
    },
    "verify": {
      "title": "E-postanız doğrulanıyor",
      "checking": "Bir saniye.",
      "doneTitle": "E-posta doğrulandı",
      "doneSubtitle": "Teşekkürler, adresiniz doğrulandı.",
      "invalidTitle": "Bu bağlantı geçerli değil",
      "invalidSubtitle": "Süresi dolmuş veya daha önce kullanılmış olabilir. Uygulamadaki hatırlatmadan yeni bir bağlantı isteyebilirsiniz.",
      "continue": "Çalışma alanınıza devam edin"
    }
  },
  "settings": {
    "security": {
      "title": "Güvenlik",
      "totp": {
        "title": "Doğrulayıcı uygulama",
        "description": "Aegis, 1Password, Google Authenticator veya Microsoft Authenticator gibi bir uygulamayla girişe ikinci bir adım ekleyin.",
        "enable": "Doğrulayıcı kur",
        "enabled": "Doğrulayıcı açık. Her girişte kod istenir.",
        "disable": "Kapat",
        "scan": "Kodu doğrulayıcı uygulamanızla tarayın, ardından gösterdiği 6 haneli kodu girin.",
        "manual": "Ya da bu anahtarı elle girin:",
        "qrAlt": "Doğrulayıcı uygulama için QR kodu",
        "firstCode": "Uygulamadaki kod",
        "confirm": "Aç",
        "recoveryTitle": "Kurtarma kodlarınızı saklayın",
        "recoveryHint": "Telefonunuzu kaybederseniz her kod bir kez çalışır. Bir daha gösterilmeyecek."
      },
      "sessions": {
        "title": "Açık oturumlarınız",
        "current": "bu cihaz",
        "unknownClient": "Bilinmeyen istemci",
        "lastSeen": "son etkinlik",
        "revoke": "Çıkış yap"
      },
      "passkeys": {
        "title": "Passkey'ler",
        "description": "Parola yerine parmak izi, yüz veya cihaz PIN'i ile giriş yapın. Passkey aynı zamanda ikinci adım sayılır.",
        "name": "Ad",
        "namePlaceholder": "Örneğin: İş bilgisayarı",
        "defaultName": "Passkey",
        "add": "Passkey ekle",
        "unsupported": "Bu tarayıcı passkey desteklemiyor.",
        "none": "Henüz passkey yok.",
        "synced": "eşitlenmiş",
        "added": "eklendi {{date}}",
        "lastUsed": "son kullanım {{date}}",
        "remove": "Kaldır"
      },
      "password": {
        "title": "Parola",
        "description": "Yeni bir parola seçin. Diğer cihazlardan çıkış yapılır; bu cihaz açık kalır.",
        "current": "Mevcut parola",
        "new": "Yeni parola",
        "confirm": "Yeni parolayı tekrar yazın",
        "submit": "Parolayı değiştir",
        "done": "Parola değiştirildi. Diğer cihazlardan çıkış yapıldı."
      }
    },
    "team": {
      "inviteTitle": "Birini davet edin",
      "role": "Rol",
      "invite": "Davet et",
      "pendingTitle": "Bekleyen davetler",
      "none": "Bekleyen davet yok.",
      "invitedBy": "davet eden {{name}}",
      "expires": "son gün {{date}}",
      "revoke": "İptal et",
      "sent": "Davet {{email}} adresine gönderildi",
      "sentHint": "Kabul etmek için {{days}} günü var. Ulaşmazsa yeniden gönderin veya bağlantıyı kendiniz paylaşın.",
      "notSent": "{{email}} adresine e-posta gönderilemedi. Bağlantıyı kendiniz paylaşın; bir kez çalışır ve {{days}} günde dolar.",
      "showLink": "Bağlantıyı göster",
      "hideLink": "Bağlantıyı gizle",
      "resend": "Yeniden gönder"
    },
    "notifications": {
      "title": "Bu cihazda yeni posta",
      "intro": "Uygulama kapalıyken bile posta geldiğinde bildirim alın. Her tarayıcı veya kurulu uygulama ayrı ayrı açılır.",
      "on": "Bu cihazda açık",
      "off": "Bu cihazda kapalı",
      "turnOn": "Aç",
      "turnOff": "Kapat",
      "sendTest": "Deneme gönder",
      "testSent_one": "Deneme {{count}} cihaza gönderildi.",
      "testSent_other": "Deneme {{count}} cihaza gönderildi.",
      "devices_one": "{{count}} cihaz bildirim alıyor",
      "devices_other": "{{count}} cihaz bildirim alıyor",
      "privacy": "Gönderen ve konu uçtan uca şifrelenir; push servisi bunları okuyamaz.",
      "serverOff": "Bu sunucuda bildirimler henüz kurulmadı.",
      "unsupported": "Bu tarayıcı bildirimleri desteklemiyor.",
      "noWorker": "Bildirimler, service worker'ın çalıştığı kurulu uygulamada veya üretim derlemesinde çalışır.",
      "blocked": "Bu site için bildirimler engellenmiş. Tarayıcının site ayarlarından izin verip yeniden deneyin."
    },
    "mail": {
      "title": "Posta yazma",
      "signature": "İmza",
      "signatureHint": "Yeni iletilerin ve yanıtların altına eklenir. Düz metin.",
      "undoSend": "Gönderimi geri alma",
      "undoSendHint": "Gönderilen ileti sunucuda ne kadar bekletilsin ki geri alabilesiniz.",
      "undoOff": "Kapalı",
      "undoSeconds_one": "{{count}} saniye",
      "undoSeconds_other": "{{count}} saniye",
      "swipeRight": "Sağa kaydırma",
      "swipeLeft": "Sola kaydırma",
      "swipeHint": "Telefonda listedeki bir iletiyi sağa ya da sola kaydırarak bu işlemleri yapın.",
      "swipeActions": {
        "archive": "Arşivle",
        "delete": "Sil",
        "read": "Okundu / okunmadı yap",
        "star": "Yıldız ekle / kaldır",
        "none": "Hiçbiri"
      }
    }
  },
  "errors": {
    "invalid_credentials": "E-posta veya şifre hatalı. Hesap e-postanızı ya da posta kutusu adresinizi, WebSede şifrenizle (uygulama şifresi değil) kullanabilirsiniz.",
    "email_taken": "Bu e-posta ile bir hesap zaten var.",
    "weak_password": "Lütfen e-postanızı içermeyen daha güçlü bir parola seçin.",
    "invalid_code": "Bu kod geçerli değil. Telefonunuzun saatini kontrol edip tekrar deneyin.",
    "mfa_required": "Devam etmek için ikinci adımı tamamlayın.",
    "invite_not_found": "Bu davet artık geçerli değil.",
    "tenant_unavailable": "Bu çalışma alanı kullanılamıyor.",
    "forbidden": "Bunu yapmaya yetkiniz yok.",
    "totp_already_enabled": "Zaten bir doğrulayıcı kurulu.",
    "request_failed": "İstek başarısız oldu. Lütfen tekrar deneyin.",
    "passkey_invalid": "Passkey doğrulanamadı. Tekrar deneyin.",
    "passkey_unknown": "Bu passkey burada kayıtlı değil.",
    "passkey_challenge_missing": "Passkey isteğinin süresi doldu. Tekrar deneyin.",
    "passkey_challenge_invalid": "Passkey isteğinin süresi doldu. Tekrar deneyin.",
    "passkey_not_found": "Bu passkey artık yok.",
    "csrf_token_invalid": "Oturumunuzun yenilenmesi gerekiyor. Sayfayı yenileyip tekrar deneyin.",
    "csrf_rejected": "Bu istek güvenlik nedeniyle engellendi. Sayfayı yenileyip tekrar deneyin.",
    "token_invalid": "Bu bağlantı artık geçerli değil.",
    "token_expired": "Bu bağlantının süresi doldu. Yeni bir tane isteyin.",
    "password_breached": "Bu parola bir veri sızıntısında görülmüş. Başka hiçbir yerde kullanmadığınız bir parola seçin.",
    "password_unchanged": "Burada kullanmadığınız bir parola seçin.",
    "cannot_change_self": "Kendi hesabınız için hesap ayarlarını kullanın.",
    "owner_only": "Bunu yalnızca sahip yapabilir ve sahip bu yolla değiştirilemez.",
    "user_not_found": "Bu üye artık yok.",
    "account_suspended": "Bu hesap askıya alınmış. Çalışma alanı yöneticinize başvurun.",
    "domain_not_purchasable": "Alan adlarından biri artık kaydedilemiyor. Güncel durumu görmek için tekrar arayın.",
    "order_not_found": "Böyle bir sipariş yok.",
    "renewal_unavailable": "Bu alan adının registrar'ı şu an yenileme sunmuyor.",
    "domain_not_found": "Böyle bir alan adı yok.",
    "invalid_term": "Bu uzantı için bu yenileme süresi geçerli değil.",
    "domain_locked": "Önce transfer kilidini kapatın.",
    "registrar_unavailable": "Bu alan adının registrar'ı şu an ulaşılamıyor.",
    "no_mailbox": "Henüz bir posta kutunuz yok.",
    "mailbox_exists": "Bu üyenin zaten bir posta kutusu var.",
    "address_taken": "Bu adres zaten kullanımda.",
    "domain_mail_not_set_up": "Önce bu alan adı için e-posta DNS'ini kurun.",
    "email_not_found": "Bu ileti artık yok.",
    "mailbox_not_found": "Böyle bir posta kutusu yok.",
    "ai_quota_exceeded": "Bu ayki yapay zeka işlemlerinizin tamamını kullandınız.",
    "ai_unavailable": "Asistan şu anda kullanılamıyor. Birazdan yeniden deneyin.",
    "offline": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip yeniden deneyin.",
    "note_conflict": "Bu not bu arada başka biri tarafından değiştirildi.",
    "note_read_only": "Bu notu okuyabilirsiniz ama değiştiremezsiniz.",
    "note_owner_only": "Bunu yalnızca notun sahibi yapabilir.",
    "person_not_found": "Bu iş arkadaşı çalışma alanında bulunamadı.",
    "too_late": "Geç kalındı, ileti zaten gönderildi.",
    "message_rejected": "Posta sunucusu bu iletiyi kabul etmedi.",
    "recipients_refused": "Posta sunucusu alıcıların hiçbirini kabul etmedi, ileti gönderilmedi. İleti Taslaklar'da duruyor.",
    "empty_upload": "Dosya boş.",
    "too_large": "Dosya 50 MB'tan büyük.",
    "subscription_required": "Çalışma alanınız duraklatıldı. Posta göndermek ve değişiklik yapmak için bir plan seçin.",
    "card_required": "Deneme süresinde çalışma alanı dışına posta göndermeye devam etmek için Faturalandırma'dan kart ekleyin.",
    "trial_mailbox_limit": "Deneme en fazla 5 posta kutusu içerir. Daha fazlası için bir plan seçin.",
    "plan_upgrade_required": "Planınız bunu içermiyor. Team planı içeriyor.",
    "no_billing_account": "Önce bir plan seçin.",
    "interval_not_offered": "Bu plan yalnızca yıllık faturalanır.",
    "feature_disabled": "Bu özellik kullanılamıyor.",
    "signup_closed": "Kayıt açılışta başlayacak. Erken erişim için support@websede.com adresine yazın.",
    "confirmation_mismatch": "Ad, çalışma alanının adıyla eşleşmiyor.",
    "alias_limit": "Bu posta kutusu en fazla takma ad sayısına ulaştı.",
    "group_limit": "Bu çalışma alanı en fazla grup adresi sayısına ulaştı.",
    "invalid_members": "Üyeleri bu çalışma alanının posta kutularından seçin.",
    "from_not_allowed": "Bu adresten gönderemezsiniz.",
    "domain_in_use": "Önce bu alan adındaki posta kutularını, takma adları ve grup adreslerini silin.",
    "sending_paused": "Bu çalışma alanından dış adreslere gönderim (davetler dahil) durduruldu. Yeniden açmak için support@websede.com adresine yazın.",
    "complimentary": "Bu çalışma alanı faturalanmıyor.",
    "invite_limit": "Bir çalışma alanında en fazla 50 bekleyen davet olabilir. Yenilerini göndermeden önce bazılarını iptal edin.",
    "invite_rate_limited": "Bir çalışma alanı saatte en fazla 30 davet gönderebilir. Biraz bekleyip yeniden deneyin.",
    "rate_limited": "Çok fazla istek gönderildi. Biraz bekleyip yeniden deneyin.",
    "wrong_password": "WebSede parolanız doğru değil.",
    "wrong_password_or_code": "WebSede parolanız ya da kod doğru değil."
  },
  "common": {
    "loading": "Yükleniyor",
    "retry": "Tekrar dene",
    "cancel": "Vazgeç",
    "save": "Kaydet",
    "copy": "Kopyala",
    "copied": "Kopyalandı",
    "errorGeneric": "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
    "unavailableTitle": "Hizmet kullanılamıyor",
    "unavailableSubtitle": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.",
    "saved": "Kaydedildi",
    "close": "Kapat",
    "showPassword": "Parolayı göster",
    "hidePassword": "Parolayı gizle"
  },
  "email": {
    "footer": {
      "account": "WebSede · Bu adres bir WebSede hesabına ait olduğu için bu iletiyi aldınız.",
      "invite": "WebSede · {{tenant}} çalışma alanının yöneticilerinden {{inviter}} bu adresi davet ettiği için bu iletiyi aldınız."
    },
    "verify": {
      "subject": "E-posta adresinizi doğrulayın",
      "greeting": "Merhaba {{name}},",
      "body": "Lütfen bu adresin size ait olduğunu doğrulayın. Bağlantı {{hours}} saat geçerlidir.",
      "action": "E-postayı doğrula",
      "ignore": "Bir WebSede hesabı oluşturmadıysanız bu iletiyi yok sayabilirsiniz."
    },
    "reset": {
      "subject": "Parolanızı sıfırlayın",
      "greeting": "Merhaba {{name}},",
      "body": "Bu hesap için parola sıfırlama istendi. Bağlantı {{minutes}} dakika geçerlidir ve bir kez kullanılabilir.",
      "action": "Yeni parola seç",
      "ignore": "Bu isteği siz yapmadıysanız iletiyi yok sayın; parolanız değişmez."
    },
    "invite": {
      "subject": "{{inviter}} sizi {{tenant}} çalışma alanına davet etti",
      "greeting": "Merhaba,",
      "body": "{{inviter}} ({{inviterEmail}}) sizi WebSede üzerindeki {{tenant}} çalışma alanına {{role}} olarak davet etti. Bağlantı {{days}} gün geçerlidir ve bir kez kullanılabilir.",
      "action": "Daveti kabul et",
      "ignore": "{{inviter}} adını tanımıyorsanız bu iletiyi yok sayın; siz onaylamadan hiçbir şey olmaz."
    },
    "passwordChanged": {
      "subject": "Parolanız değiştirildi",
      "greeting": "Merhaba {{name}},",
      "body": "WebSede hesabınızın parolası {{when}} UTC tarihinde değiştirildi ve diğer tüm cihazlardan çıkış yapıldı. Bunu siz yaptıysanız yapmanız gereken bir şey yok.",
      "action": "Siz değil miydiniz? Parolanızı hemen sıfırlayın",
      "ignore": "Değişikliği siz yapmadıysanız yukarıdaki bağlantıyla hemen sıfırlayın ve çalışma alanı yöneticinize haber verin."
    },
    "mfaReset": {
      "subject": "İkinci adımınız sıfırlandı",
      "greeting": "Merhaba {{name}},",
      "body": "Çalışma alanınızın yöneticisi {{actor}}, doğrulayıcı uygulamanızı ve passkey'lerinizi kaldırdı ve tüm cihazlardan çıkış yaptı. Parolanızla giriş yapıp yeniden kurabilirsiniz.",
      "action": "Yeni ikinci adım kur",
      "ignore": "Bunu siz istemediyseniz hemen çalışma alanı yöneticinize haber verin."
    },
    "expiryAutoRenew": {
      "subject": "{{domain}} {{days}} gün içinde yenilenecek",
      "greeting": "Merhaba {{name}},",
      "body": "{{domain}} alan adının süresi {{date}} tarihinde doluyor. Otomatik yenileme açık; bu tarihten kısa süre önce kayıtlı kartınızdan çekim yapıp süreyi bir yıl uzatacağız. Kayıtlı kartın geçerli olduğundan emin olun.",
      "action": "Alan adlarınızı gözden geçirin",
      "ignore": "Yenilemeyi durdurmak için çekim tarihinden önce otomatik yenilemeyi kapatın."
    },
    "expiryManual": {
      "subject": "{{domain}} süresi {{days}} gün içinde doluyor",
      "greeting": "Merhaba {{name}},",
      "body": "{{domain}} alan adının süresi {{date}} tarihinde doluyor ve otomatik yenileme kapalı. Alan adını tutacaksanız bu tarihten önce yenileyin; süre dolduktan sonra registry kurtarma ücreti alır ve ad kaybedilebilir.",
      "action": "Şimdi yenile",
      "ignore": "Süresinin dolmasını istiyorsanız yapmanız gereken bir şey yok."
    },
    "renewed": {
      "subject": "{{domain}} yenilendi",
      "greeting": "Merhaba {{name}},",
      "body": "{{domain}} otomatik olarak {{amount}} karşılığında yenilendi; yeni son tarih {{date}}. Makbuz siparişlerinizde.",
      "action": "Alan adlarınızı görün",
      "ignore": "Bu iletiyi bu alan adında otomatik yenileme açık olduğu için alıyorsunuz."
    },
    "autoRenewFailed": {
      "subject": "İşlem gerekli: {{domain}} yenilenemedi",
      "greeting": "Merhaba {{name}},",
      "body": "{{domain}} alan adını otomatik yenilemeyi denedik ancak ödeme başarısız oldu: {{reason}}. Alan adının süresi {{date}} tarihinde doluyor. Her gün yeniden deneyeceğiz; yeni bir kartla şimdi de yenileyebilirsiniz.",
      "action": "Şimdi yenile",
      "ignore": "Alan adının süresi dolacaksa bu iletileri durdurmak için otomatik yenilemeyi kapatın."
    },
    "sendingPaused": {
      "subject": "Dış adreslere gönderim durduruldu",
      "greeting": "Merhaba {{name}},",
      "body": "Çalışma alanınızdan dış adreslere giden postaları durdurduk: {{reason}}. Bu, alan adlarınızın ve diğer herkesin itibarını korur. Gelen postalar ulaşmaya devam eder; WebSede web uygulamasından çalışma alanınızdaki kişilere yine yazabilirsiniz. Telefon ve bilgisayar e-posta uygulamaları ise gönderim yeniden açılana kadar hiçbir ileti gönderemez. Bu iletiyi yanıtlayın veya {{support}} adresine yazın; sizinle birlikte inceleyip gönderimi yeniden açacağız.",
      "action": "Yönetim konsolunu aç",
      "ignore": "Sık görülen nedenler: eski bir kişi listesi, parolası çalınmış bir posta kutusu ya da alıcıların beklemediği iletiler.",
      "reasonComplaints": "son 24 saatte {{count}} spam şikâyeti",
      "reasonBounces": "son 24 saatte var olmayan adreslere giden {{count}} ileti"
    }
  },
  "banner": {
    "unverified": "Hesabınızın kurtarılabilir kalması için e-posta adresinizi doğrulayın. {{email}} adresine bir bağlantı gönderdik.",
    "resend": "Tekrar gönder",
    "resent": "Gönderildi"
  },
  "admin": {
    "console": "Yönetim konsolu",
    "backToMail": "Postaya dön",
    "onlyAdmins": "Yalnızca sahipler ve yöneticiler görebilir.",
    "auditNote": "Burada yapılan değişiklikler tüm çalışma alanını etkiler.",
    "nav": {
      "overview": "Genel bakış",
      "users": "Kullanıcılar",
      "domains": "Alan adları",
      "audit": "Denetim günlüğü",
      "billing": "Faturalandırma"
    },
    "tenantStatus": {
      "trial": "Deneme",
      "active": "Etkin",
      "suspended": "Askıda",
      "closed": "Kapalı"
    },
    "overview": {
      "members": "Üye",
      "mfa": "Doğrulayıcısı olan",
      "pendingInvites": "Bekleyen davet",
      "unverified": "Doğrulanmamış e-posta",
      "nextSteps": "Sonraki adımlar",
      "inviteLink": "Ekibinizi davet edin ve kimin ikinci adımı olduğunu görün",
      "domainLink": "Postanız için bir alan adı bulun",
      "securityLink": "Kendi hesabınızı passkey ile koruyun",
      "mailboxes": "Posta kutuları",
      "domains": "Alan adları",
      "pendingCount_one": "{{count}} davet bekliyor",
      "pendingCount_other": "{{count}} davet bekliyor",
      "domainHint": "Maliyetine alan adı kaydedin ya da sahip olduğunuzu bağlayın",
      "securityHint": "İki adımlı doğrulama ve geçiş anahtarları",
      "unverifiedNote_one": "{{count}} üye e-posta adresini henüz doğrulamadı.",
      "unverifiedNote_other": "{{count}} üye e-posta adresini henüz doğrulamadı.",
      "rename": "Çalışma alanını yeniden adlandır"
    },
    "users": {
      "members": "Üyeler",
      "user": "Kullanıcı",
      "security": "Güvenlik",
      "lastSignIn": "Son giriş",
      "mfaOn": "doğrulayıcı açık",
      "mfaOff": "doğrulayıcı yok",
      "unverified": "e-posta doğrulanmamış",
      "actions": {
        "manage": "Yönet",
        "close": "Kapat",
        "you": "siz",
        "suspended": "askıda",
        "role": "Rol",
        "transferOwnership": "Sahip (sahipliği devret)",
        "saveRole": "Rolü kaydet",
        "suspend": "Askıya al",
        "reactivate": "Geri aç",
        "signOutEverywhere": "Tüm cihazlardan çıkış yaptır",
        "resetMfa": "İkinci adımı sıfırla",
        "sendReset": "Parola sıfırlama bağlantısı gönder",
        "confirmSuspend": "{{name}} askıya alınsın mı? Oturumları kapanır ve geri açılana kadar giriş yapamaz. Postası gelmeye devam eder.",
        "confirmResetMfa": "{{name}} kullanıcısının doğrulayıcısı ve passkey'leri kaldırılsın mı? Tüm cihazlardan çıkış yapılır ve yeniden kurması istenir.",
        "confirmTransfer": "Sahiplik {{name}} kullanıcısına devredilsin mi? Siz yönetici olursunuz.",
        "done": "Tamamlandı."
      }
    },
    "audit": {
      "title": "Denetim günlüğü",
      "description": "Girişler, kimlik bilgisi değişiklikleri, davetler ve yönetici eylemleri. Bir yıl saklanır; kayıtlar düzenlenemez ve silinemez.",
      "filterAll": "Tüm olaylar",
      "filterAuth": "Girişler ve kimlik bilgileri",
      "filterInvites": "Davetler",
      "filterMembers": "Üye yönetimi",
      "filterDns": "DNS",
      "when": "Zaman",
      "actor": "Kim",
      "event": "Olay",
      "target": "Hedef",
      "from": "Nereden",
      "export": "CSV dışa aktar",
      "loadMore": "Daha eski olayları yükle",
      "empty": "Henüz kayıt yok.",
      "system": "sistem",
      "actions": {
        "auth.signed_in": "Giriş yapıldı",
        "auth.signed_out": "Çıkış yapıldı",
        "auth.session_revoked": "Oturum sonlandırıldı",
        "auth.email_verified": "E-posta adresi doğrulandı",
        "auth.password_changed": "Parola değiştirildi",
        "auth.password_reset": "Parola e-posta bağlantısıyla sıfırlandı",
        "auth.totp_enabled": "Doğrulayıcı uygulama açıldı",
        "auth.totp_disabled": "Doğrulayıcı uygulama kapatıldı",
        "auth.passkey_added": "Passkey eklendi",
        "auth.passkey_removed": "Passkey kaldırıldı",
        "invite.created": "Davet gönderildi",
        "invite.resent": "Davet yeniden gönderildi",
        "invite.revoked": "Davet iptal edildi",
        "invite.accepted": "Davet kabul edildi, hesap oluşturuldu",
        "member.role_changed": "Rol değiştirildi",
        "member.ownership_transferred": "Sahiplik devredildi",
        "member.suspended": "Üye askıya alındı",
        "member.reactivated": "Üye geri açıldı",
        "member.sessions_revoked": "Üye tüm cihazlardan çıkarıldı",
        "member.mfa_reset": "Üyenin ikinci adımı sıfırlandı",
        "member.password_reset_sent": "Üyeye parola sıfırlama bağlantısı gönderildi",
        "dns.email_setup_applied": "E-posta DNS kayıtları yazıldı",
        "order.created": "Sipariş oluşturuldu",
        "order.paid": "Sipariş ödendi",
        "domain.registered": "Alan adı kaydedildi",
        "domain.registration_failed": "Alan adı kaydı başarısız",
        "domain.renewed": "Alan adı yenilendi",
        "domain.auto_renew_failed": "Otomatik yenileme başarısız",
        "domain.auto_renew_changed": "Otomatik yenileme değiştirildi",
        "domain.settings_changed": "Alan adı ayarları değiştirildi",
        "domain.nameservers_changed": "Ad sunucuları değiştirildi",
        "domain.auth_code_viewed": "Transfer kodu görüntülendi",
        "mailbox.created": "Posta kutusu oluşturuldu",
        "mailbox.deleted": "Posta kutusu silindi",
        "mailbox.password_reset": "Posta kutusu uygulama parolası yenilendi",
        "domain.connected": "Alan adı bağlandı",
        "domain.verified": "Alan adı sahipliği doğrulandı",
        "domain.disconnected": "Alan adı bağlantısı kaldırıldı",
        "mailbox.alias_added": "Takma ad eklendi",
        "mailbox.alias_removed": "Takma ad kaldırıldı",
        "mail_group.created": "Grup adresi oluşturuldu",
        "mail_group.updated": "Grup adresi değiştirildi",
        "mail_group.deleted": "Grup adresi silindi",
        "workspace.sending_paused": "Dış gönderim durduruldu",
        "workspace.sending_resumed": "Dış gönderim yeniden açıldı",
        "workspace.queued_mail_released": "Bekletilen giden postalar gönderime bırakıldı",
        "workspace.queued_mail_cancelled": "Bekletilen giden postalar iptal edildi",
        "workspace.renamed": "Çalışma alanı yeniden adlandırıldı"
      },
      "filterOrders": "Siparişler ve alan adları",
      "filterMail": "Posta kutuları"
    },
    "mailboxes": {
      "title": "Posta kutuları",
      "noDomain": "Önce bir alan adında e-posta kurun; posta kutuları alan adlarınızda yaşar.",
      "address": "Adres",
      "create": "Posta kutusu oluştur",
      "secretTitle": "{{address}} için uygulama parolası",
      "secretHint": "Telefon ve masaüstü posta uygulamaları için (IMAP ve SMTP). Bir kez gösterilir; kaybolursa yenisini üretin.",
      "newPassword": "Yeni uygulama parolası",
      "delete": "Sil",
      "confirmDelete": "{{address}} ve içindeki her şey silinsin mi? Geri alınamaz."
    },
    "brand": "Yönetim",
    "aliases": {
      "add": "Takma ad ekle",
      "save": "Ekle",
      "remove": "{{address}} adresini kaldır",
      "confirmRemove": "{{address}} takma adı kaldırılsın mı? Bu adrese gelen postalar artık ulaşmaz."
    },
    "groups": {
      "title": "Grup adresleri",
      "body": "ekip@ veya satis@ gibi, birden çok posta kutusuna ulaşan bir adres. Her üye kendi kopyasını alır.",
      "needMailboxes": "Önce bir posta kutusu oluşturun; grup adresleri posta kutularına iletir.",
      "name": "Ad",
      "namePlaceholder": "Satış ekibi",
      "members": "Üyeler",
      "create": "Grup adresi oluştur",
      "edit": "Düzenle",
      "save": "Kaydet",
      "delete": "Sil",
      "confirmDelete": "{{address}} silinsin mi? Bu adrese gelen postalar artık ulaşmaz."
    }
  },
  "checkout": {
    "title": "Alan adı kaydet",
    "term": "Süre",
    "years_one": "{{count}} yıl",
    "years_other": "{{count}} yıl",
    "registrant": "Kayıt sahibi",
    "registrantHint": "Registry'ler sahip için doğrulanmış kimlik bilgisi ister (NIS2). WHOIS gizliliği bu bilgileri herkese açık olmaktan çıkarır; registrar'da kayıtlı kalır.",
    "firstName": "Ad",
    "lastName": "Soyad",
    "organization": "Kuruluş (isteğe bağlı)",
    "email": "E-posta",
    "phone": "Telefon (uluslararası biçim)",
    "street": "Sokak",
    "city": "Şehir",
    "postalCode": "Posta kodu",
    "country": "Ülke kodu",
    "state": "Eyalet veya il (isteğe bağlı)",
    "privacy": "WHOIS gizliliği (ücretsiz)",
    "summary": "Sipariş",
    "wholesale": "Registry toptan fiyatı",
    "icann": "ICANN ücreti",
    "processing": "Kart komisyonu",
    "total": "Toplam",
    "pay": "{{amount}} öde",
    "unavailable": "Bu alan adı şu an kaydedilemiyor: {{reason}}.",
    "note": "Registry'nin bizden aldığı ücret, ICANN ücreti ve kart komisyonu dışında hiçbir şey ödemezsiniz. Registry kabul ettikten sonra kayıtlar iade edilmez.",
    "hosted": "Ödeme barındırılan bir sayfada yapılır; kart bilgileri WebSede'ye hiç ulaşmaz."
  },
  "order": {
    "title": "Sipariş",
    "status": {
      "pending_payment": "Ödeme bekleniyor",
      "paid": "Ödendi, alan adları kaydediliyor",
      "completed": "Tamamlandı",
      "partially_failed": "Hatalarla tamamlandı",
      "failed": "Tamamlanamadı",
      "cancelled": "İptal edildi"
    },
    "cancelledNote": "Ödeme iptal edildi. Ücret alınmadı ve alan adı kaydedilmedi.",
    "waiting": "Ödeme sağlayıcısından onay bekleniyor. Bu sayfa kendini yeniler.",
    "resume": "Ödemeye devam et",
    "items": "Alan adları",
    "registered": "kaydedildi",
    "failed": "başarısız",
    "pending": "bekliyor",
    "expires": "son gün {{date}}",
    "manage": "Alan adlarınıza gidin",
    "reference": "Ödeme referansı",
    "list": "Tüm siparişler",
    "placed": "oluşturuldu {{date}}"
  },
  "domain": {
    "settings": "Ayarlar",
    "autoRenew": "Otomatik yenileme",
    "lock": "Transfer kilidi",
    "lockHint": "Başka bir registrar'a transferi engeller. Yalnızca alan adını taşırken kapatın.",
    "whois": "WHOIS gizliliği",
    "whoisHint": "Kayıt sahibi bilgilerini herkese açık WHOIS'ten gizler. Ücretsiz.",
    "email": {
      "title": "E-posta kurulumu",
      "description": "Tek tıkla MX, SPF, DKIM, DMARC, autoconfig ve CalDAV kayıtları alan adının DNS bölgesine yazılır ve alan adı posta platformunda açılır.",
      "done": "kuruldu {{date}}",
      "notYet": "kurulmadı",
      "apply": "E-posta DNS'ini kur",
      "reapply": "Kayıtları yeniden uygula",
      "result": "{{created}} oluşturuldu, {{updated}} güncellendi, {{unchanged}} değişmedi."
    },
    "nameservers": {
      "title": "Ad sunucuları",
      "ours": "Alan adı bizim DNS'imize yönlendirilmiş; aşağıdaki kayıtlar canlı.",
      "external": "Alan adı dış ad sunucularına yönlendirilmiş; bizim DNS'e dönene kadar aşağıdaki kayıtlar kullanılmaz.",
      "useOurs": "Bizim ad sunucularımızı kullan"
    },
    "records": {
      "title": "Bölgemizdeki DNS kayıtları",
      "none": "Henüz bölge yok. E-posta kurun veya ad sunucularımıza geçin."
    },
    "transfer": {
      "title": "Dışarı transfer",
      "description": "Bu alan adını başka bir registrar'a taşımak için yetki kodu gerekir. Dışarı transfer ücretsizdir.",
      "unlockFirst": "Kodu görmek için yukarıdaki transfer kilidini kapatın.",
      "reveal": "Yetki kodunu göster"
    },
    "verify": {
      "title": "Sahipliği doğrulayın",
      "description": "Bu TXT kaydını alan adının DNS'ini barındıran firmaya (genellikle kayıt firmanız) ekleyin, sonra kontrol edin. Değişikliklerin görünmesi birkaç dakika sürebilir.",
      "type": "Tür",
      "name": "Ad / host",
      "value": "Değer",
      "check": "Şimdi kontrol et",
      "notFound": "Henüz bulunamadı. DNS, {{fqdn}} adresinde eşleşen bir kayıt göstermiyor.",
      "foundOther": "DNS, {{fqdn}} adresinde başka değerler gösteriyor: {{values}}",
      "done": "{{date}} tarihinde doğrulandı",
      "copy": "Kopyala",
      "copied": "Kopyalandı",
      "fullName": "Tam ad {{fqdn}}. Bazı DNS sağlayıcıları yalnızca kayıtlı alan adınızdan önceki kısmı ister."
    },
    "dnsCheck": {
      "title": "E-posta DNS kayıtları",
      "description": "Bu kayıtları DNS sağlayıcınıza ekleyin; zorunlu olanlardan başlayın.",
      "ready": "Posta hazır: MX, SPF ve DKIM yerinde.",
      "notReady": "Bazı zorunlu kayıtlar eksik ya da farklı.",
      "recommendedMissing_one": "{{count}} önerilen kayıt eksik ya da farklı",
      "recommendedMissing_other": "{{count}} önerilen kayıt eksik ya da farklı",
      "check": "Tekrar kontrol et",
      "checked": "{{date}} kontrol edildi",
      "level": {
        "required": "Zorunlu",
        "recommended": "Önerilen",
        "optional": "İsteğe bağlı"
      },
      "levelHint": {
        "required": "Bunlar olmadan posta gelmez ya da güvenilir sayılmaz.",
        "recommended": "Posta bunlar olmadan da çalışır; ama DMARC postanın gelen kutusuna ulaşmasına yardımcı olur, SRV kayıtları da e-posta, takvim ve kişiler uygulamalarının sunucuları kendiliğinden bulmasını sağlar.",
        "optional": "Bunları henüz çok az uygulama kullanıyor; atlayabilirsiniz."
      },
      "found": "bulunan: {{values}}",
      "status": {
        "ok": "Tamam",
        "missing": "eksik",
        "mismatch": "farklı"
      }
    },
    "external": {
      "title": "Başka yerde kayıtlı",
      "description": "Yenileme, transfer kilidi ve ad sunucuları bu alan adını aldığınız kayıt firmasında yönetilir."
    },
    "disconnect": {
      "title": "Bağlantıyı kaldır",
      "description": "Alan adını bu çalışma alanından ve posta platformundan kaldırır. Önce üzerindeki posta kutularını silin.",
      "button": "Alan adının bağlantısını kaldır",
      "confirm": "{{domain}} bağlantısı kaldırılsın mı? Bu adrese gönderilen postalar artık buraya gelmeyecek."
    }
  },
  "mail": {
    "noMailbox": "Henüz bir posta kutunuz yok.",
    "createInConsole": "Yönetim konsolunda posta kutusu oluşturun",
    "askAdmin": "Bir çalışma alanı yöneticisinden sizin için oluşturmasını isteyin.",
    "compose": "Yeni ileti",
    "newMessage": "Yeni ileti",
    "to": "Kime",
    "cc": "Bilgi",
    "subject": "Konu",
    "send": "Gönder",
    "reply": "Yanıtla",
    "flag": "İşaretle",
    "unflag": "İşareti kaldır",
    "markUnread": "Okunmadı yap",
    "archive": "Arşivle",
    "delete": "Sil",
    "refresh": "Yenile",
    "empty": "Burada bir şey yok.",
    "pickOne": "Okumak için bir ileti seçin.",
    "count_one": "{{count}} ileti",
    "count_other": "{{count}} ileti",
    "folders": {
      "inbox": "Gelen kutusu",
      "sent": "Gönderilmiş",
      "drafts": "Taslaklar",
      "trash": "Çöp",
      "junk": "İstenmeyen",
      "archive": "Arşiv"
    },
    "search": "Bu klasörde ara",
    "loadOlder": "Daha eski iletileri yükle",
    "images": "Uzak görselleri yükle",
    "imagesBlocked": "Siz yükleyene kadar uzak görseller engellenir.",
    "attachments": "Ekler",
    "shortcuts": "Tuşlar: j/k gezin · Enter aç · r yanıtla · c yeni · e arşivle · # sil · s işaretle · u okunmadı · / ara · Esc kapat",
    "live": "canlı",
    "polling": "30 sn'de bir kontrol",
    "summarize": "Özetle",
    "draftReply": "Yanıt taslağı",
    "aiInstructions": "Yanıtta ne olmalı, asistana söyleyin (isteğe bağlı)",
    "aiWorking": "Düşünüyor…",
    "useDraft": "Yanıt olarak kullan",
    "aiRemaining_one": "Bu ay {{count}} yapay zeka işlemi kaldı",
    "aiRemaining_other": "Bu ay {{count}} yapay zeka işlemi kaldı",
    "aiNote": "Modele yalnızca bu ileti ve notunuz gönderilir. Göndermeden önce sonucu kontrol edin.",
    "back": "Geri",
    "addCc": "Cc ekle",
    "recipientSource": {
      "contact": "kişi",
      "directory": "iş arkadaşı",
      "recent": "son"
    },
    "attach": "Dosya ekle",
    "dropFiles": "veya dosyaları buraya bırakın",
    "uploading": "yükleniyor…",
    "uploadFailed": "yüklenemedi",
    "tooLarge": "50 MB'tan büyük",
    "removeAttachment": "{{name}} dosyasını kaldır",
    "draftSaving": "Taslak kaydediliyor…",
    "draftSaved": "Taslak kaydedildi",
    "discard": "Sil",
    "sendingIn": "{{seconds}} sn içinde gönderiliyor",
    "sentNow": "İleti gönderildi",
    "undo": "Geri al",
    "tooLate": "Geç kalındı, ileti gitti.",
    "notDeliveredTo": "Teslim edilemedi: {{recipients}}",
    "notSentRefused": "Gönderilmedi: posta sunucusu şu alıcıları kabul etmedi: {{recipients}}. İleti Taslaklar'da duruyor.",
    "searchMail": "Postalarda ara",
    "clearSearch": "Aramayı temizle",
    "results": "Arama sonuçları",
    "noResults": "Aramanızla eşleşen ileti yok.",
    "range": "{{from}}–{{to}} / {{total}}",
    "noSubject": "(konu yok)",
    "noRecipient": "(alıcı yok)",
    "star": "Yıldız ekle",
    "unstar": "Yıldızı kaldır",
    "position": "{{position}} / {{total}}",
    "newer": "Daha yeni",
    "older": "Daha eski",
    "toLine": "alıcı: {{recipients}}",
    "attachmentCount_one": "{{count}} ek",
    "attachmentCount_other": "{{count}} ek",
    "forward": "İlet",
    "forwardedHeader": "İletilen ileti",
    "from": "Gönderen",
    "date": "Tarih",
    "redraft": "Yeniden yaz",
    "expand": "Genişlet",
    "minimize": "Küçült",
    "body": "İleti",
    "recipientsPlaceholder": "Alıcılar",
    "needRecipient": "En az bir alıcı ekleyin.",
    "invalidRecipient": "Geçerli bir e-posta adresi değil: {{value}}. Adresleri virgülle ayırın.",
    "select": "Seç",
    "selectOptions": "İletileri seç",
    "selectMessage": "Seç: {{subject}}",
    "selectWhich": {
      "all": "Tümü",
      "none": "Hiçbiri",
      "read": "Okunmuş",
      "unread": "Okunmamış",
      "starred": "Yıldızlı",
      "unstarred": "Yıldızsız"
    },
    "selectedCount_one": "{{count}} seçili",
    "selectedCount_other": "{{count}} seçili",
    "clearSelection": "Seçimi kaldır",
    "markRead": "Okundu olarak işaretle",
    "reportSpam": "Spam bildir",
    "notSpam": "Spam değil",
    "moveTo": "Taşı",
    "moveToInbox": "Gelen kutusuna taşı"
  },
  "calendar": {
    "today": "Bugün",
    "newEvent": "Yeni etkinlik",
    "editEvent": "Etkinliği düzenle",
    "eventTitle": "Başlık",
    "calendar": "Takvim",
    "allDay": "Tüm gün",
    "date": "Tarih",
    "start": "Başlangıç",
    "end": "Bitiş",
    "location": "Konum",
    "description": "Açıklama",
    "delete": "Etkinliği sil",
    "untitled": "(başlıksız)",
    "create": "Oluştur",
    "myCalendars": "Takvimlerim",
    "previous": "Önceki",
    "next": "Sonraki",
    "view": "Görünüm",
    "views": {
      "day": "Gün",
      "threeDays": "3 gün",
      "week": "Hafta",
      "month": "Ay",
      "schedule": "Program"
    },
    "addAllDay": "Tüm gün etkinlik ekle",
    "more_one": "{{count}} tane daha",
    "more_other": "{{count}} tane daha",
    "nothingPlanned": "Planlanmış bir şey yok",
    "addTitle": "Başlık ekle",
    "addLocation": "Konum ekle",
    "addDescription": "Açıklama ekle"
  },
  "contacts": {
    "search": "Kişilerde ara",
    "newContact": "Yeni kişi",
    "editContact": "Kişiyi düzenle",
    "givenName": "Ad",
    "familyName": "Soyad",
    "organization": "Şirket",
    "emails": "E-posta adresleri",
    "phones": "Telefon numaraları",
    "onePerLine": "Her satıra bir tane",
    "notes": "Notlar",
    "delete": "Kişiyi sil",
    "empty": "Kişileriniz burada görünecek.",
    "pickOne": "Bir kişi seçin veya yeni oluşturun.",
    "create": "Kişi oluştur",
    "all": "Kişiler",
    "name": "Ad",
    "email": "E-posta",
    "phone": "Telefon",
    "noName": "(adsız)",
    "noMatch": "Aramanızla eşleşen kişi yok.",
    "edit": "Düzenle",
    "sendEmail": "E-posta",
    "call": "Ara",
    "details": "İletişim bilgileri",
    "noDetails": "Henüz bilgi yok.",
    "confirmDelete": "{{name}} silinsin mi?",
    "addEmail": "E-posta ekle",
    "addPhone": "Telefon ekle",
    "removeValue": "Kaldır",
    "other": "Diğer kişiler",
    "otherHint": "E-posta gönderdiğiniz kişiler burada saklanır; böylece yanıtları gelen kutunuza düşer.",
    "otherEmpty": "E-posta gönderdiğiniz kişiler burada görünecek.",
    "addToContacts": "Kişilere ekle"
  },
  "store": {
    "headline": "Kendi alan adınızla iş e-postası.",
    "subline": "Küçük işletmeler için posta, takvim, kişiler ve görevler. Gizliliğe saygılı, reklamsız ve her e-posta uygulamasıyla çalışır. 14 gün ücretsiz deneyin, kart gerekmez.",
    "openWorkspace": "Çalışma alanını aç",
    "createWorkspace": "Çalışma alanı oluştur",
    "points": {
      "suite": {
        "title": "Tek çalışma alanı",
        "body": "Alan adınızda posta, takvim, kişiler, görevler ve notlar; her telefon ve bilgisayar uygulaması için açık protokoller."
      },
      "private": {
        "title": "Gizlilik esaslı",
        "body": "Reklam yok, izleme yok ve postanız asla yapay zekâ eğitiminde kullanılmaz. Her şeyi istediğiniz zaman dışa aktarın."
      },
      "cost": {
        "title": "Dürüst fiyat",
        "body": "Posta kutusu başına sabit fiyat, tuzak indirim yok; yönetim konsolundan istediğiniz zaman iptal edin."
      }
    }
  },
  "tasks": {
    "newList": "Yeni liste",
    "addPlaceholder": "Görev yazın ve Enter'a basın",
    "empty": "Burada yapılacak bir şey yok.",
    "completed_one": "{{count}} tamamlandı",
    "completed_other": "{{count}} tamamlandı",
    "markDone": "Tamamlandı olarak işaretle",
    "markOpen": "Tamamlanmadı olarak işaretle",
    "title": "Başlık",
    "important": "Önemli",
    "dueDate": "Bitiş tarihi",
    "dueTime": "Saat",
    "list": "Liste",
    "notes": "Notlar",
    "subtasks": "Alt görevler",
    "addSubtask": "Alt görev ekle",
    "delete": "Görevi sil",
    "fromEmail": "Bir e-postadan",
    "openEmail": "E-postayı aç: {{subject}}",
    "addFromEmail": "Görev olarak ekle",
    "added": "Görevlere eklendi",
    "create": "Oluştur",
    "sortBy": "Görevleri sırala",
    "sortManual": "Benim sıram",
    "sortDue": "Bitiş tarihi",
    "dragHint": "Sürükleyip sırala",
    "moveUp": "Yukarı taşı",
    "moveDown": "Aşağı taşı",
    "reminder": "Hatırlatıcı",
    "reminderNone": "Hatırlatıcı yok",
    "reminderAtDue": "Bitiş anında",
    "reminder15": "15 dakika önce",
    "reminder60": "1 saat önce",
    "reminder1440": "1 gün önce",
    "reminderDay9": "O gün 09:00'da",
    "reminderDayBefore9": "Bir gün önce 09:00'da",
    "reminderCustomBefore": "{{minutes}} dakika önce",
    "reminderCustomAfter": "{{minutes}} dakika sonra",
    "reminderNeedsDue": "Hatırlatıcı eklemek için bitiş tarihi seçin.",
    "reminderWhere": "Telefon ve masaüstü takvim uygulamalarında ve burada bildirimleri açık cihazlarda çalar.",
    "notificationSettings": "Bildirim ayarları",
    "addTask": "Görev ekle",
    "starred": "Yıldızlı",
    "lists": "Listeler",
    "newListName": "Liste adı",
    "search": "Görevlerde ara",
    "noMatch": "Aramanızla eşleşen görev yok.",
    "noStarred": "Yıldızladığınız görevler burada görünür.",
    "addDetails": "Ayrıntı ekle",
    "clearDue": "Tarihi kaldır"
  },
  "notes": {
    "all": "Tüm notlar",
    "notebooks": "Defterler",
    "newNotebook": "Yeni defter",
    "tags": "Etiketler",
    "search": "Notlarda ara",
    "newNote": "Yeni not",
    "empty": "Burada henüz not yok.",
    "pickOne": "Bir not seçin veya yeni oluşturun.",
    "untitled": "Başlıksız",
    "pin": "Sabitle",
    "unpin": "Sabitlemeyi kaldır",
    "color": "Renk",
    "colors": {
      "yellow": "Sarı",
      "green": "Yeşil",
      "blue": "Mavi",
      "purple": "Mor",
      "pink": "Pembe",
      "gray": "Gri"
    },
    "notebook": "Defter",
    "noNotebook": "Defter yok",
    "saving": "Kaydediliyor…",
    "title": "Başlık",
    "tagsPlaceholder": "Etiketler, virgülle ayırın",
    "edit": "Yaz",
    "preview": "Oku",
    "markdownHint": "Markdown: # başlık, **kalın**, - [ ] liste",
    "export": "Markdown olarak dışa aktar",
    "delete": "Notu sil",
    "confirmDelete": "Bu not silinsin mi? Geri alınamaz.",
    "saveFromEmail": "Not olarak kaydet",
    "saved": "Notlara kaydedildi",
    "fromSender": "Gönderen {{from}}:",
    "sharedWithMe": "Benimle paylaşılanlar",
    "share": "Paylaş",
    "sharedWith_one": "{{count}} kişiyle paylaşıldı",
    "sharedWith_other": "{{count}} kişiyle paylaşıldı",
    "shareTitle": "Bu notu açabilen kişiler",
    "searchPeople": "Ad veya e-postayla iş arkadaşı ekleyin",
    "add": "Ekle",
    "remove": "Kaldır",
    "noPeople": "Eşleşen iş arkadaşı yok.",
    "canEdit": "düzenleyebilir",
    "canView": "görüntüleyebilir",
    "permission": "{{name}} neler yapabilir",
    "sharedBy": "Paylaşan: {{name}}",
    "leave": "Ayrıl",
    "conflict": "Siz yazarken bu notu başka biri kaydetti. Yazdıklarınız burada duruyor.",
    "conflictShort": "Kaydedilmedi: başka yerde değişti",
    "loadTheirs": "Onların sürümünü göster",
    "keepMine": "Benim sürümümü koru",
    "notSaved": "Kaydedilmedi",
    "takeNote": "Not alın…",
    "pinned": "Sabitlenenler",
    "others": "Diğerleri",
    "notebookName": "Defter adı",
    "noMatch": "Aramanızla eşleşen not yok.",
    "emptyNote": "Boş not",
    "noColor": "Varsayılan",
    "body": "Not"
  },
  "shell": {
    "menu": "Ana menü",
    "closeMenu": "Menüyü kapat",
    "apps": "Uygulamalar",
    "account": "Hesap",
    "language": "Dil",
    "theme": {
      "title": "Görünüm",
      "light": "Açık",
      "dark": "Koyu",
      "system": "Sistem"
    }
  },
  "devices": {
    "intro": "Postanızı, takviminizi ve kişilerinizi telefonunuzdaki ya da bilgisayarınızdaki uygulamalarda kullanın.",
    "password": {
      "title": "Uygulama şifresi",
      "why": "E-posta uygulamaları WebSede şifrenizle değil, e-posta adresiniz ve bir uygulama şifresiyle giriş yapar.",
      "confirm": "WebSede şifreniz",
      "replaces": "Yeni uygulama şifresi eskisinin yerini alır: eskisini kullanan uygulamalar yenisini ister.",
      "create": "Uygulama şifresi oluştur",
      "shownOnce": "Yalnızca bir kez gösterilir. Şimdi uygulamaya girin; gerekirse her zaman yenisini oluşturabilirsiniz."
    },
    "apple": {
      "title": "iPhone, iPad ve Mac",
      "what": "Tek bir profil posta, takvim ve kişileri ekler.",
      "step1": "Bu sayfayı cihazda Safari ile açın ve Profili indir'e dokunun.",
      "step2": "Ayarlar'ı açın, en üstteki Profil İndirildi'ye, sonra Yükle'ye dokunun.",
      "step3": "Şifre sorulduğunda uygulama şifresini girin.",
      "download": "Profili indir",
      "unverified": "Profil henüz imzalı değil, bu yüzden iOS \"Doğrulanmamış\" gösterir. Bu beklenen bir durum."
    },
    "android": {
      "title": "Android",
      "mail": "Gmail uygulamasında posta",
      "mail1": "Gmail'de profil resminize, sonra <b>Başka bir hesap ekle</b> ve <b>Diğer</b>'e dokunun.",
      "mail2": "<b>{{address}}</b> adresini girin, <b>Kişisel (IMAP)</b> seçin ve uygulama şifresini girin.",
      "mail3": "Gmail gelen sunucu alanına <b>{{domain}}</b> yazar. Bunu <b>{{host}}</b> ile değiştirin; bağlantı noktasını ve güvenlik türünü Gmail kendisi seçer.",
      "mail4": "Giden sunucu ekranında Gmail yine <b>{{domain}}</b> yazar; bunu da <b>{{host}}</b> ile değiştirin.",
      "outbox": "Gönderdiğiniz postalar Giden Kutusu'nda kalırsa hesabı Gmail'den kaldırıp yeniden ekleyin.",
      "dav": "Takvim ve kişiler",
      "dav1": "<b>DAVx⁵</b> uygulamasını yükleyin (F-Droid'de ücretsiz, Google Play'de ücretli).",
      "dav2": "<b>URL ve kullanıcı adıyla giriş</b> seçin: URL <b>{{url}}</b>, kullanıcı adı <b>{{address}}</b>, uygulama şifresi.",
      "dav3": "Eşitlenecek takvim ve adres defterlerini seçin; telefonun kendi uygulamalarında görünürler."
    },
    "manual": {
      "title": "Sunucu ayarları",
      "auto": "Thunderbird ve klasik Outlook bu ayarları çoğunlukla kendileri bulur: adresinizi ve uygulama şifresini girmeniz yeterli. Uygulama {{host}} sunucusundaki kurulum bilgilerini kullanıp kullanamayacağını sorarsa onaylayın. Diğer uygulamalara aşağıdaki ayarları girin.",
      "username": "Kullanıcı adı",
      "password": "Şifre",
      "passwordValue": "Uygulama şifreniz",
      "imap": "Gelen (IMAP)",
      "smtp": "Giden (SMTP)",
      "smtpAlt": "Giden, diğer port",
      "dav": "Takvim ve kişiler"
    }
  },
  "billing": {
    "yourPlan": "Planınız",
    "plans": "Planlar",
    "monthly": "Aylık",
    "yearly": "Yıllık · 2 ay bedava",
    "perMailboxMonth": "posta kutusu başına / ay",
    "perMailboxYear": "posta kutusu başına / yıl",
    "perMonth": "ay",
    "perYear": "yıl",
    "seatsLine_one": "{{count}} posta kutusu × {{unit}} = {{period}} başına {{total}}",
    "seatsLine_other": "{{count}} posta kutusu × {{unit}} = {{period}} başına {{total}}",
    "trialEnds_one": "Ücretsiz deneme {{date}} tarihinde bitiyor ({{count}} gün kaldı).",
    "trialEnds_other": "Ücretsiz deneme {{date}} tarihinde bitiyor ({{count}} gün kaldı).",
    "renewsOn": "{{date}} tarihinde yenilenir.",
    "endsOn": "{{date}} tarihinde bitiyor; yenilenmeyecek.",
    "manage": "Ödeme ve faturaları yönet",
    "noCardYet": "Henüz kayıtlı kart yok. Aşağıdan bir plan seçin; süren deneme bitene kadar ücretsiz kalır.",
    "activating": "Teşekkürler! Planınız etkinleştiriliyor; birkaç saniye sürer.",
    "current": "Mevcut plan",
    "choose": "{{plan}} seç",
    "switchTo": "{{plan}} planına geç",
    "confirmSwitch": "Plan şimdi değiştirilsin mi? Fiyat farkı bir sonraki faturanıza orantılı yansır.",
    "footnote": "Fiyatlar posta kutusu başına ABD doları cinsindendir. Satış vergisi eklenebilir. İstediğiniz zaman Ödeme ve faturaları yönet'ten iptal edebilirsiniz.",
    "notesNotInPlan": "Notlar Team planına dahildir. Notlarınız saklanıyor ve okumaya devam edebilirsiniz.",
    "access": {
      "trial": "Ücretsiz deneme",
      "active": "Etkin",
      "past_due": "Ödeme başarısız",
      "expired": "Duraklatıldı"
    },
    "banner": {
      "trialEnds_one": "Ücretsiz denemeniz {{count}} gün içinde bitiyor.",
      "trialEnds_other": "Ücretsiz denemeniz {{count}} gün içinde bitiyor.",
      "cardNeeded_one": "Çalışma alanı dışına ve telefon/bilgisayar e-posta uygulamalarından göndermeye devam etmek için kart ekleyin. Deneme {{count}} gün içinde bitiyor.",
      "cardNeeded_other": "Çalışma alanı dışına ve telefon/bilgisayar e-posta uygulamalarından göndermeye devam etmek için kart ekleyin. Deneme {{count}} gün içinde bitiyor.",
      "pastDue": "Son ödemeniz başarısız oldu. Çalışma alanınızın devam etmesi için kartınızı güncelleyin.",
      "expired": "Çalışma alanınız duraklatıldı: posta gelmeye devam ediyor, ancak göndermek için bir plan gerekiyor.",
      "choose": "Plan seç",
      "fix": "Kartı güncelle",
      "askAdmin": "Bir çalışma alanı yöneticisine başvurun.",
      "sendingPaused": "Geri dönen postalar veya spam şikâyetleri nedeniyle dış adreslere gönderim durduruldu. Gelen postalar ulaşmaya devam ediyor ve web uygulamasından çalışma alanınızdaki kişilere yine gönderebilirsiniz; telefon ve bilgisayar e-posta uygulamaları ise gönderim yeniden açılana kadar gönderemez. Yeniden açmak için {{support}} adresine yazın."
    },
    "plan": {
      "personal": {
        "name": "Personal",
        "tagline": "Kendi alan adınızla profesyonel e-posta.",
        "features": [
          "Posta kutusu başına 10 GB e-posta",
          "Takvim ve kişiler",
          "Görevler",
          "Telefon ve bilgisayar e-posta uygulamalarıyla çalışır"
        ]
      },
      "team": {
        "name": "Team",
        "tagline": "Birlikte çalışan küçük ekipler için.",
        "features": [
          "Personal'daki her şey",
          "Posta kutusu başına 25 GB e-posta",
          "Ekibinizle paylaşılan notlar"
        ]
      }
    },
    "firstCharge": "{{date}} tarihine kadar ücretsiz; ilk ödeme o gün alınır.",
    "yearlyOnly": "Yalnızca yıllık faturalanır, aylık {{amount}}",
    "complimentary": {
      "title": "Ücretsiz çalışma alanı",
      "body": "Bu çalışma alanı Team planının özelliklerine sahiptir ve hiç faturalanmaz. Posta kutuları serbestçe eklenebilir."
    }
  },
  "public": {
    "nav": {
      "pricing": "Fiyatlar",
      "startTrial": "Ücretsiz deneyin",
      "comingSoon": "Çok yakında"
    },
    "contact": "İletişim",
    "home": {
      "seePricing": "Fiyatları gör"
    },
    "legal": {
      "terms": "Koşullar",
      "privacy": "Gizlilik",
      "refunds": "İadeler",
      "acceptableUse": "Kabul edilebilir kullanım",
      "draft": "Taslak: bu belge gözden geçiriliyor ve henüz yürürlükte değil.",
      "notFound": "Bu sayfa yok."
    },
    "pricing": {
      "title": "Posta kutusu başına basit fiyat",
      "subtitle": "Her plan kendi alan adınızı, güvenli girişi ve zaten kullandığınız uygulamaları içerir. Aylık ödeyin ya da yıllık ödeyip iki ay bedava alın.",
      "trialNote": "Her çalışma alanı 14 günlük ücretsiz Team denemesiyle başlar. Başlamak için kart gerekmez.",
      "faqTitle": "Sorular",
      "faq": {
        "trial": {
          "q": "Ücretsiz deneme nasıl işliyor?",
          "a": "En fazla 5 posta kutusuyla 14 gün Team planını kullanırsınız. Çalışma alanı dışına posta göndermeye devam etmek için ilk 3 gün içinde kart ekleyin; ücret yalnızca deneme bitince alınır."
        },
        "card": {
          "q": "Hangi ödeme yöntemlerini kabul ediyorsunuz?",
          "a": "Tüm yaygın kredi ve banka kartları; ödemeleri Stripe güvenle işler. Kart numaranızı asla görmeyiz ve saklamayız."
        },
        "cancel": {
          "q": "İstediğim zaman iptal edebilir miyim?",
          "a": "Evet. Yönetim konsolundaki Faturalandırma'dan iptal edin; planınız ödediğiniz dönemin sonuna kadar sürer. İlk ödemeniz 30 gün para iade garantisi kapsamındadır."
        },
        "tax": {
          "q": "Vergiler dahil mi?",
          "a": "Fiyatlar ABD doları cinsindendir ve satış vergisi hariçtir; yasanın gerektirdiği yerlerde eklenir."
        },
        "domain": {
          "q": "Kendi alan adıma ihtiyacım var mı?",
          "a": "Evet. Zaten sahip olduğunuz bir alan adını bağlayın; eklemeniz gereken DNS kayıtlarını gösterir ve sizin için kontrol ederiz."
        }
      }
    }
  },
  "dataControls": {
    "account": {
      "title": "Verileriniz",
      "body": "Profilinizi, notlarınızı, takvimlerinizi, kişilerinizi ve görevlerinizi JSON dosyası olarak indirin. İletiler e-posta uygulamalarınızda kalır: IMAP ile dışa aktarın.",
      "download": "Verilerimi indir"
    },
    "workspace": {
      "title": "Çalışma alanı verileri",
      "body": "Çalışma alanının kayıtlarını indirin: üyeler, alan adları, posta kutuları, faturalandırma ve denetim günlüğü, JSON dosyası olarak. Her üye kendi notlarını, takvimlerini ve kişilerini Ayarlar'dan indirir.",
      "download": "Çalışma alanı verilerini dışa aktar"
    },
    "close": {
      "title": "Çalışma alanını kapat",
      "body": "{{name}} kapatılınca abonelik hemen biter, kimse bir daha giriş yapamaz ve gönderim durur. Önce ihtiyacınız olanı dışa aktarın. Posta kutuları 30 gün boyunca e-posta uygulamalarından (IMAP) okunabilir, sonra her şey silinir. Bu 30 gün içinde yeniden açmak için destekle iletişime geçin.",
      "name": "Onaylamak için çalışma alanının adını ({{name}}) yazın",
      "password": "Şifreniz",
      "submit": "Çalışma alanını kapat",
      "confirm": "Çalışma alanı şimdi kapatılsın mı? Herkesin oturumu hemen kapanır.",
      "done": "Çalışma alanı kapatıldı. Verileri {{date}} tarihinde silinecek. Oturumunuz kapatılıyor."
    }
  }
}
